import {combineReducers, configureStore} from '@reduxjs/toolkit';
import {Middleware} from 'redux';
import thunk from 'redux-thunk';

import {
  accountSlice,
  adminSlice,
  authenticationSlice,
  brandSlice,
  distributorSlice,
  marketSlice,
  orderSlice,
  positionSlice,
  productSlice,
  retailerSlice,
  speculatorSlice,
  userSlice,
  verificationSlice,
} from '../reducers';
// Import Middleware type
import themeReducer from '../reducers/themeSlice';

const rootReducer = combineReducers({
  verification: verificationSlice.reducer,
  user: userSlice.reducer,
  authentication: authenticationSlice.reducer,
  account: accountSlice.reducer,
  speculator: speculatorSlice.reducer,
  admin: adminSlice.reducer,
  brand: brandSlice.reducer,
  product: productSlice.reducer,
  position: positionSlice.reducer,
  retailer: retailerSlice.reducer,
  theme: themeReducer,
  market: marketSlice.reducer,
  distributor: distributorSlice.reducer,
  order: orderSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const middleware: Middleware[] = [thunk]; // Define an array of middleware

const store = configureStore({
  reducer: rootReducer,
  middleware: middleware, // Pass the middleware array
});

export default store;
